var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-paginator" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-default",
        attrs: { disabled: !_vm.prev_page_url },
        on: {
          click: function ($event) {
            return _vm.fetchData(_vm.prev_page_url)
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.config.previous_button_text) + "\n  ")]
    ),
    _vm._v(" "),
    _c("span", [
      _vm._v(
        "Page " + _vm._s(_vm.current_page) + " of " + _vm._s(_vm.last_page)
      ),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-default",
        attrs: { disabled: !_vm.next_page_url },
        on: {
          click: function ($event) {
            return _vm.fetchData(_vm.next_page_url)
          },
        },
      },
      [_vm._v("\n    " + _vm._s(_vm.config.next_button_text) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }